import axios from 'axios';
import { downloadBlob } from '../../utils';

const getBackupFileName = (contentDisposition?: string) => {
  const match = contentDisposition?.match(/filename="?([^";]+)"?/i);

  if (match?.[1]) return match[1];

  const timestamp = new Date().toISOString().replace(/[:.]/g, '-').replace('Z', '');
  return `tezport-backup-${timestamp}.json.gz`;
};

class BackupService {
  download = async () => {
    const response = await axios.get('/backups/download', {
      responseType: 'blob',
    });

    downloadBlob(response.data, getBackupFileName(response.headers['content-disposition']));
  };
}

export const backupService = new BackupService();
